import I18n from "common/i18n";

/**
 * タイトル用フォントを取得（OtomanopeeOne-Regular / NotoSans-Bold / NotoSansTC-Bold / NotoSansSC-Bold）
 * 用途: CourseTitleSvg, FreebuildTitleSvg など装飾的なタイトル
 */
export const getTitleFont = (): string => {
  switch (I18n.locale) {
    case "en":
      return "NotoSans-Bold, sans-serif";
    case "zh_tw":
      return "NotoSansTC-Bold, sans-serif";
    case "zh_cn":
      return "NotoSansSC-Bold, sans-serif";
    default:
      return "OtomanopeeOne-Regular, sans-serif";
  }
};

/**
 * 本文/UI用フォントを取得（MPLUSRounded1c-Bold / NotoSans-Bold / NotoSansTC-Bold / NotoSansSC-Bold）
 * 用途: Success画面、LevelAnimation、ゲーム内テキストなど
 */
export const getBodyFont = (): string => {
  switch (I18n.locale) {
    case "en":
      return "NotoSans-Bold";
    case "zh_tw":
      return "NotoSansTC-Bold";
    case "zh_cn":
      return "NotoSansSC-Bold";
    default:
      return "MPLUSRounded1c-Bold";
  }
};
